import {Component} from "@angular/core";
import {ModalService, CorrespondantStore, NotificationService} from "@digicerba/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CanalNotificationWithMessageCountDto,
  CorrespondantDto,
  INotificationsWebServiceClient,
  ITechnicWebServiceClient,
  SaveMessageNotificationDto
} from "@common/resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {ModalComponent} from "./modal/modal.component";
import {AsiDialogService} from "@asi-ngtools/lib";
import * as moment from "moment";


@Component({
  selector: 'publication-message-component',
  templateUrl: './publication.message.component.html',
  host: {'class': 'page'}
})
export class PublicationMessageComponent {
  messageForm: FormGroup;
  canaux: CanalNotificationWithMessageCountDto[];
  correspondants: Array<CorrespondantDto>;

  modules: string[] = [];

  constructor(private router: Router, private asiDialogService: AsiDialogService, private fb: FormBuilder, private activatedRoute: ActivatedRoute, private notif: INotificationsWebServiceClient,
              private correspondantStore: CorrespondantStore, private notificationsWebServiceClient: INotificationsWebServiceClient, private modalService: ModalService,
              private technicWebServiceClient: ITechnicWebServiceClient, private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.correspondants = new Array<CorrespondantDto>();
    this.technicWebServiceClient.getCorrespondants().subscribe(data => {
      this.correspondants = data;
    });
    this.canaux = this.activatedRoute.snapshot.data['canaux'];
    this.modules = this.activatedRoute.snapshot.data['modules'];
    this.modules.forEach((str:String) => {
      console.log(str)
    })
    this.messageForm = this.fb.group({
      title: [null, Validators.required],
      description: [null, Validators.required],
      canauxDiffusion: [null, Validators.required],
      url: [null],
      correspondant: [null],
      miseEnAvant:[null],
      module:[null],
      from:[null],
      to:[null]
    });
  }

  isCorrespondant(): boolean {

    if (this.messageForm.value.canauxDiffusion != null) {
      return this.messageForm.value.canauxDiffusion.typeAutorisation === 'CORRESPONDANT';
    } else {
      return false;
    }
  }

  isMiseEnAvant(): boolean {

    if (this.messageForm.value.miseEnAvant != null) {
      return this.messageForm.value.miseEnAvant;
    }
    return false;
  }

  submit() {
    if (!this.messageForm.valid) {
      return;
    }
    let newMessage = new SaveMessageNotificationDto;

    let titre = this.messageForm.value.title;
    let description = this.messageForm.value.description;
    let canalId = this.messageForm.value.canauxDiffusion.id;
    let url = this.messageForm.value.url;
    let correspondant = this.messageForm.value.correspondant;
    let miseEnAvant = this.messageForm.value.miseEnAvant;
    let module = this.messageForm.value.module;
    let from = this.messageForm.value.from;
    let to = this.messageForm.value.to;


    newMessage.titre = titre;
    newMessage.description = description;
    newMessage.canalId = canalId;
    newMessage.url = url;
    if (correspondant) {
      newMessage.correspondant = correspondant.code;
    }
    if(miseEnAvant == true){
      newMessage.miseEnAvant = miseEnAvant;
      newMessage.module = module;

      newMessage.from = moment(from).format("DD/MM/YYYY");
      console.log(newMessage.from)
      newMessage.to = moment(to).format("DD/MM/YYYY");
      console.log(newMessage.to)
    }

    this.notificationsWebServiceClient.createMessageNotification(newMessage).subscribe((success) => {
      if(success){
        this.router.navigate(['cerba/canaux']);
      }
      else{
        this.notificationService.showErrorNotification("Erreur lors de l'enregistrement de la notification");
      }
    });

  }

  goCanaux() {
    this.router.navigate(['cerba/canaux']);
  }

  public modifierValidation(canalNotificationWithMessageCountDto: CanalNotificationWithMessageCountDto) {

    if (canalNotificationWithMessageCountDto.typeAutorisation === 'CORRESPONDANT') {
      this.messageForm.controls.correspondant.setValidators([Validators.required]);
    } else {
      this.messageForm.controls.correspondant.clearValidators();
    }
    this.messageForm.controls.correspondant.updateValueAndValidity();
  }

  showDialog() {

    let asiDialog = this.asiDialogService.fromComponent(ModalComponent, null);

    asiDialog.getComponent().message = 'Prévisualisation de votre message';
    asiDialog.getComponent().messageForm = this.messageForm;
  }


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/message/publication/publication.message.component.ts